import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Search } from "lucide-react";
import { SECTIONS } from "@/lib/sections";

export function filterMembers(members, section, search) {
  let list = section === "all" ? members : members.filter((m) => m.section === section);
  if (!search) return list;
  const q = search.toLowerCase();
  return list.filter((m) =>
    m.full_name.toLowerCase().includes(q) ||
    (m.parent_guardian || "").toLowerCase().includes(q) ||
    (m.email || "").toLowerCase().includes(q)
  );
}

export default function MemberFilters({ members, activeTab, onTabChange, search, onSearch }) {
  const count = (v) => members.filter((m) => m.section === v).length;
  return (
    <div className="flex flex-col md:flex-row gap-3 md:items-center">
      <Tabs value={activeTab} onValueChange={onTabChange} className="w-full md:w-auto">
        <TabsList className="flex flex-wrap h-auto gap-1">
          <TabsTrigger value="all" data-testid="tab-all">All ({members.length})</TabsTrigger>
          {SECTIONS.map((s) => (
            <TabsTrigger key={s.value} value={s.value} data-testid={`tab-${s.value}`}>{s.label} ({count(s.value)})</TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
      <div className="relative flex-1 max-w-md">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input data-testid="search-members" placeholder="Search name, parent, email…" value={search} onChange={(e) => onSearch(e.target.value)} className="pl-9 min-h-[44px]" />
      </div>
    </div>
  );
}
